import React, { createContext, useContext, useState, ReactNode } from 'react';
import ComposeModal from '@/components/email/ComposeModal';

interface ComposeData {
  type?: 'new' | 'reply' | 'forward' | 'draft';
  to?: { value: string; label: string }[];
  cc?: { value: string; label: string }[];
  bcc?: { value: string; label: string }[];
  subject?: string;
  body?: string;
  attachments?: File[];
  draftId?: string;
}

interface ComposeContextType {
  isComposeOpen: boolean;
  openCompose: (data?: ComposeData) => void;
  closeCompose: () => void;
  composeData?: ComposeData;
}

const ComposeContext = createContext<ComposeContextType | undefined>(undefined);

export const useCompose = () => {
  const context = useContext(ComposeContext);
  if (context === undefined) {
    throw new Error('useCompose must be used within a ComposeProvider');
  }
  return context;
};

interface ComposeProviderProps {
  children: ReactNode;
}

export const ComposeProvider: React.FC<ComposeProviderProps> = ({ children }) => {
  const [isComposeOpen, setIsComposeOpen] = useState(false);
  const [composeData, setComposeData] = useState<ComposeData>();

  const openCompose = (data?: ComposeData) => {
    setComposeData(data);
    setIsComposeOpen(true);
  };

  const closeCompose = () => {
    setIsComposeOpen(false);
    setComposeData(undefined);
  };

  return (
    <ComposeContext.Provider value={{ isComposeOpen, openCompose, closeCompose, composeData }}>
      {children}
      {isComposeOpen && (
        <ComposeModal 
          isOpen={isComposeOpen} 
          onClose={closeCompose}
          initialData={composeData}
        />
      )}
    </ComposeContext.Provider>
  );
}; 